import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SeoAudit } from '../shared/models/seo-audits/seo-audit';

@Injectable({
  providedIn: 'root'
})
export class SeoAuditService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/seoaudit`;

  constructor(private http: HttpClient) { }

  getLatest(customerId: number): Observable<SeoAudit> {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.get<SeoAudit>(`${this.baseUrl}/getLatest`, { params: params });
  }
}